import { render, staticRenderFns } from "./RefuseCommentModal.vue?vue&type=template&id=06612c64&"
import script from "./RefuseCommentModal.vue?vue&type=script&lang=js&"
export * from "./RefuseCommentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports